module.exports = __webpack_public_path__ + "static/img/strona_026.17b88a57.jpg";